import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  CmpStatusIcon,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Box, Card, CardContent, Typography } from "@mui/material";
export const SummaryTblCardv1 = ({ data = [], onClick = () => {} }) => {
  let xsLabel = 2.2;
  let xsColon = 0.1;
  let xsValue = 3.7;

  let mdLabel = 3;
  let mdColon = 0.5;
  let mdValue = 8.5;
  return (
    <Grid container spacing={2} marginTop={2}>
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              "& .MuiCardContent-root": {
                padding: "0px !important",
              },
            }}
          >
            <CardContent>
              <Box sx={{ backgroundColor: "#FAF9F6", p: 1.5 }}>
                {/* Name and Position */}
                <Grid container alignItems={"center"}>
                  <Grid item xs={11}>
                    <Typography
                      variant="Subtitle2"
                      fontWeight="bold"
                      noWrap
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                      }}
                    >
                      {item.VocNo}
                    </Typography>
                    <Typography variant="subtitle2" color="gray">
                      {item.VocName}
                    </Typography>
                    <Typography variant="subtitle2" color="gray">
                      {moment(item.A_VocDt).format("DD/MM/YYYY")}
                    </Typography>
                  </Grid>
                  <Grid item xs={1} textAlign={"right"}>
                    {/* <CmpStatusIconV3 xStatus={item?.Indicator} /> */}
                    <CmpStatusIcon xStatus={item.Status} xfontSize="small" />
                  </Grid>
                </Grid>
              </Box>
              <Box
                display="flex"
                justifyContent={"space-between"}
                paddingX={1.5}
              >
                <Typography variant="Subtitle2" color="primary" marginTop={1}>
                  <strong> {item.LocName}</strong>
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: "#F4F4F4",
                  borderRadius: 2,
                  p: "10px",
                  mt: 0.5,
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography variant="caption" color="gray">
                      DropId
                    </Typography>
                    <br />
                    <Typography variant="Subtitle2" fontWeight="bold">
                      {item.A_DropId}
                    </Typography>
                  </Grid>
                  {item.BrName && (
                    <Grid item xs={6}>
                      <Typography variant="caption" color="gray">
                        Branch
                      </Typography>
                      <br />
                      <Typography variant="Subtitle2" fontWeight="bold">
                        {item.BrName}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Box>
              <Box
                display="flex"
                justifyContent={"center"}
                paddingX={1.5}
                pb={1}
              >
                <Typography
                  variant="Subtitle2"
                  color="primary"
                  marginTop={1}
                  fontWeight="bold !important"
                >
                  {item.RequestLocName}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
